import React, { useEffect, useMemo } from "react"

import modStyl from './index.module.scss'
import avatar from '../assets/images/man.jpg'
import storageX from "../../utils/storageX"
import QRCode from "qrcode.react"
import LazyIcon from "../components/lazy-icon"

const JunInvitation = ()=> {
  
  const user = useMemo(()=> storageX().user(), [])
  
  useEffect(()=> {
    document.title = '邀请患者'
  }, [])

  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.top}>
        <div className={modStyl.inner}>
          <LazyIcon name="love"/>
          <span>邀请患者</span>
          <LazyIcon name="love"/>
        </div>
      </div>
      <div className={modStyl.card}>
        <div className={modStyl.header}>
          <h2>移植患者抗巨细胞病毒治疗药物的医学观察调研项目</h2>
          <p>项目介绍：加强支持疗法，监测血常规、生化等指标，及时有效的氧疗措施，适当应用抗生素治疗。卧床休息，加强支持疗法，监测血常支持疗法。</p>
        </div>
        <div className={modStyl.body}>
          <div className={modStyl.doctor}>
            <div className={modStyl.west}>
              <img src={avatar} alt="" />
            </div>
            <div className={modStyl.east}>
              <div className={modStyl.r1}>
                <h2>{user.userName}</h2>
                <span>副主任医师</span>
              </div>
              <div className={modStyl.r2}>
                <span>肿瘤科</span>
                <span>上海第六人民医院</span>
              </div>
            </div>
          </div>
          <div className={modStyl.qr}>
            <QRCode value="敬请期待" size={200}/>
            <p className={modStyl.desc}>微信扫一扫，关注“惟一康健”公众号，添加医生</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JunInvitation
